@if(isOpen()) {
	<div class="p-8 bg-peps-dark-700 fixed bottom-30 md:bottom-26 right-10 md:right-26 flex flex-col gap-4 border-2 border-peps-gold md:w-92 z-20">
		<div class="flex flex-col gap-2">
			<span class="uppercase text-xl">Notifications de matchs</span>
			<span class="font-notosans text-sm">Pour ne rater aucun match et soutenir l'équipe, autorise les notifications !</span>
		</div>
		<div class="flex flex-col md:flex-row md:items-end md:justify-around gap-4">
			@if(isSubscribed) {
				<button
					(click)="disableNotifications()"
					class="text-peps-dark-700 bg-peps-gold py-4 px-8 cursor-pointer hover:bg-peps-yellow transition-colors duration-300 uppercase"
				>Désactiver</button>
			} @else {
				<button
					(click)="enableNotifications()"
					class="text-peps-dark-700 bg-peps-gold py-4 px-8 cursor-pointer hover:bg-peps-yellow transition-colors duration-300 uppercase"
				>Activer</button>
			}

			<button
				class="cursor-pointer hover:text-peps-orange transition-colors pb-2 duration-300 border-b-2 hover:border-b-peps-brown uppercase text-peps-gold border-b-peps-gold w-fit mx-auto"
				(click)="close()"
			>Plus tard</button>
		</div>
	</div>
}
